import { Screen } from '@epihub/web/src/routes/Screen';
import { cookieRoute } from '@krishanmadan/core/src/routes/frontendRoutes';

export const CookieScreen = Screen(cookieRoute, () => {
  window.location.href = 'https://www.iubenda.com/privacy-policy/15214437/cookie-policy';
  return null;
});
